// extracted by mini-css-extract-plugin
export default {"title":"styles_title__oT-4Y","table":"styles_table__0OKiT","prettyJson":"styles_prettyJson__fLezu"};